var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.logObject.loggedIn == true || _vm.logObject.loggedIn == 'true')?_c('div',{staticClass:"kontainer"},[_c('h1',[_vm._v("Einstellungen")]),_c('p',[_vm._v("Text")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }